module.exports = __webpack_public_path__ + "static/img/icon_video.2aa6b413.png";